import React from 'react';
import PropTypes from 'prop-types';

import PricingStatusBadge from 'features/ManageServices/Components/ServicePricingSection/PricingStatusBadge/PricingStatusBadge';

import { messages } from '../../Services.messages';
import { getManualBookableStatusDisplay } from '../ServicesList.helpers';

const listMessages = messages.list;

const ManualServiceStatus = ({ service }) => {
  const { id, disabled, retailRateRequest, price, status, classPricingRule } = service;
  const { messageKey, iconType, tooltipMessageKey } = getManualBookableStatusDisplay({
    disabled,
    retailRateRequest,
    price,
    status,
    classPricingRule,
  });

  return (
    <PricingStatusBadge
      alignedRight
      iconType={iconType}
      messageKey={messageKey}
      messages={listMessages}
      tooltipMessageKey={tooltipMessageKey}
      tooltipName={`manual-service-status-tooltip-${id}`}
    />
  );
};

ManualServiceStatus.propTypes = {
  service: PropTypes.shape({
    id: PropTypes.number,
    disabled: PropTypes.bool,
    price: PropTypes.number,
    status: PropTypes.string,
    retailRateRequest: PropTypes.shape({
      status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      statusReason: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    classPricingRule: PropTypes.shape({
      status: PropTypes.string,
    }),
  }),
};

export default ManualServiceStatus;
